import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Flex, Box, FormControl, FormLabel, Input } from "@chakra-ui/react";
import { RiDeleteBinLine } from "react-icons/ri";
import {
  setEditingMode,
  removeDropItem,
} from "../../../redux/actions/formActions";
import DragIcon from "../Icons/Drag";
const Address = ({
  field: address,
  uid: fieldId,
  isFocused,
  dispatchSetEditingMode,
  dispatchRemoveDropItem,
}) => {
  const { addressLine1, addressLine2, state, city, zipCode, country } =
    address.fields;
  const handleEditOnClick = (e) => {
    const eventType = e.target.type;
    if (!eventType) {
      dispatchSetEditingMode(fieldId);
    }
  };

  const handleDeleteOnClick = (e) => {
    e.stopPropagation();
    return dispatchRemoveDropItem(fieldId);
  };
  return (
    <Flex
      onClick={handleEditOnClick}
      cursor="pointer"
      // p="3"
      border={isFocused ? "2px solid #3182ce" : "none"}
      bg="#F5F7F9"
      align="center"
      justify="space-around"
      mb="3"
      w="592px"
      minH="112px"
      borderRadius="4px"
    >
      <div
        style={{
          marginBlockEnd: "auto",
          marginTop: "12px",
          marginLeft: "8px",
          marginRight: "9px",
        }}
      >
        <DragIcon />
      </div>
      <Box marginTop="12px" marginBottom="12px">
        {addressLine1.showField && (
          <FormControl isRequired={addressLine1.isRequired} w="100%" mb="12px">
            {address.showLabel && (
              <FormLabel
                fontSize="12px"
                fontWeight="600"
                color="#475867"
                mb="4px"
              >
                {addressLine1.label}
              </FormLabel>
            )}
            <Input
              w="498px"
              h="32px"
              borderRadius="4px"
              border="1px"
              borderStyle="solid"
              borderColor="#CFD7DF"
              type="text"
              placeholder={addressLine1.placeholder}
              bg="#FFFFFF"
            />
          </FormControl>
        )}
        {addressLine2.showField && (
          <FormControl isRequired={addressLine2.isRequired} w="100%" mt="8px">
            {address.showLabel && (
              <FormLabel
                fontSize="12px"
                fontWeight="600"
                color="#475867"
                mb="4px"
              >
                {addressLine2.label}
              </FormLabel>
            )}
            <Input
              w="498px"
              h="32px"
              borderRadius="4px"
              border="1px"
              borderStyle="solid"
              borderColor="#CFD7DF"
              type="text"
              bg="#FFFFFF"
              placeholder={addressLine2.placeholder}
            />
          </FormControl>
        )}
        <Flex w="498px" display="block">
        {city.showField && state.showField?
        <Flex justify="space-between" align="center" w="100%" mt="10px">
          {city.showField && (
            <FormControl isRequired={city.isRequired}>
              {address.showLabel && (
                <FormLabel
                  fontSize="12px"
                  fontWeight="600"
                  color="#475867"
                  mb="4px"
                >
                  {city.label}
                </FormLabel>
              )}
              <Input
                w="244px"
                h="32px"
                borderRadius="4px"
                border="1px"
                borderStyle="solid"
                borderColor="#CFD7DF"
                type="text"
                bg="#FFFFFF"
                placeholder={city.placeholder}
              />
            </FormControl>
          )}
          {state.showField && (
            <FormControl isRequired={state.isRequired} ml="8px">
              {address.showLabel && (
                <FormLabel fontSize="12px" fontWeight="600" color="#475867">
                  {state.label}
                </FormLabel>
              )}
              <Input
                w="244px"
                h="32px"
                borderRadius="4px"
                border="1px"
                borderStyle="solid"
                borderColor="#CFD7DF"
                type="text"
                bg="#FFFFFF"
                placeholder={state.placeholder}
              />
            </FormControl>
          )}
        </Flex>:""}
        {city.showField && !state.showField ?
        <FormControl isRequired={city.isRequired}  mt="10px">
              {address.showLabel && (
                <FormLabel
                  fontSize="12px"
                  fontWeight="600"
                  color="#475867"
                  mb="4px"
                >
                  {city.label}
                </FormLabel>
              )}
              <Input
                w="244px"
                h="32px"
                borderRadius="4px"
                border="1px"
                borderStyle="solid"
                borderColor="#CFD7DF"
                type="text"
                bg="#FFFFFF"
                placeholder={city.placeholder}
              />
        </FormControl>:""}
        {state.showField && !city.showField?
        <FormControl isRequired={state.isRequired} mt="10px">
        {address.showLabel && (
          <FormLabel fontSize="12px" fontWeight="600" color="#475867">
            {state.label}
          </FormLabel>
        )}
        <Input
          w="244px"
          h="32px"
          borderRadius="4px"
          border="1px"
          borderStyle="solid"
          borderColor="#CFD7DF"
          type="text"
          bg="#FFFFFF"
          placeholder={state.placeholder}
        />
        </FormControl>:""}
        
        {zipCode.showField && country.showField ? 
        <Flex justify="space-between" align="center" w="100%" mt="10px">
          {zipCode.showField && (
            <FormControl isRequired={zipCode.isRequired}>
              {address.showLabel && (
                <FormLabel fontSize="12px" fontWeight="600" color="#475867">
                  {zipCode.label}
                </FormLabel>
              )}
              <Input
                w="244px"
                h="32px"
                borderRadius="4px"
                border="1px"
                borderStyle="solid"
                borderColor="#CFD7DF"
                type="text"
                bg="#FFFFFF"
                placeholder={zipCode.placeholder}
              />
            </FormControl>
          )}
          {country.showField && (
            <FormControl isRequired={country.isRequired} ml="8px">
              {address.showLabel && (
                <FormLabel fontSize="12px" fontWeight="600" color="#475867">
                  {country.label}
                </FormLabel>
              )}
              <Input
                w="244px"
                h="32px"
                borderRadius="4px"
                border="1px"
                borderStyle="solid"
                borderColor="#CFD7DF"
                type="text"
                bg="#FFFFFF"
                placeholder={country.placeholder}
              />
            </FormControl>
          )}
        </Flex>:""}
        {zipCode.showField && !country.showField ? 
        <FormControl isRequired={zipCode.isRequired} mt="10px">
              {address.showLabel && (
                <FormLabel fontSize="12px" fontWeight="600" color="#475867">
                  {zipCode.label}
                </FormLabel>
              )}
              <Input
                w="244px"
                h="32px"
                borderRadius="4px"
                border="1px"
                borderStyle="solid"
                borderColor="#CFD7DF"
                type="text"
                bg="#FFFFFF"
                placeholder={zipCode.placeholder}
              />
        </FormControl>:""}
        {country.showField && !zipCode.showField ? 
        <FormControl isRequired={country.isRequired} mt="10px">
              {address.showLabel && (
                <FormLabel fontSize="12px" fontWeight="600" color="#475867">
                  {country.label}
                </FormLabel>
              )}
              <Input
                w="244px"
                h="32px"
                borderRadius="4px"
                border="1px"
                borderStyle="solid"
                borderColor="#CFD7DF"
                type="text"
                bg="#FFFFFF"
                placeholder={country.placeholder}
              />
        </FormControl>:""}
        </Flex>
      </Box>
      <div
        style={{
          marginBlockEnd: "auto",
          marginTop: "12px",
          marginLeft: "16px",
          marginRight: "16px",
        }}
      >
        <RiDeleteBinLine cursor="pointer" onClick={handleDeleteOnClick} />
      </div>
    </Flex>
  );
};

Address.propTypes = {
  field: PropTypes.object.isRequired,
  isFocused: PropTypes.bool,
  uid: PropTypes.string.isRequired,
  dispatchSetEditingMode: PropTypes.func.isRequired,
  dispatchRemoveDropItem: PropTypes.func.isRequired,
  dispatchUpdateField: PropTypes.func.isRequired,
};

const getFocusFieldId = (state) => {
  const { focusField } = state.form;
  return focusField && focusField.uid ? focusField.uid : null;
};

const getFieldById = (state, isFocused, uid) => {
  const { dropped, focusField } = state.form;
  return isFocused ? focusField : dropped.find((field) => field.uid == uid);
};

const isCurrentlyFocused = (state, uid) => {
  const { isEditing } = state.form;
  return isEditing && getFocusFieldId(state) == uid;
};

const mapStateToProps = (state, ownProps) => {
  const { uid } = ownProps;
  const isFocused = isCurrentlyFocused(state, uid);
  const field = getFieldById(state, isFocused, uid);
  return {
    field,
    isFocused,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    dispatchSetEditingMode: bindActionCreators(setEditingMode, dispatch),
    dispatchRemoveDropItem: bindActionCreators(removeDropItem, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Address);
